import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_DISCARDED_REASONS,
} from '../../../actions/actionTypes';

const discardedReasons = fetchReducerGenerator(
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_FETCH_DISCARDED_REASONS
);

export default discardedReasons;
